import { type Domains, domainToTenant, GRAFIT_DOMAINS, type Tenant, VINCI_DOMAINS } from "./tenant.ts";

export const SSO_PROVIDER_ID_VINCI = "vinci-energies";
export const SSO_PROVIDER_ID_GOOGLE = "google";
export const SSO_ERROR_VINCI_ACCOUNT_NOT_LINKED = "VINCI_ACCOUNT_NOT_LINKED";

export type SSO_PROVIDER = typeof SSO_PROVIDER_ID_VINCI | typeof SSO_PROVIDER_ID_GOOGLE;

export const SSO_PROVIDER_DOMAIN_MAP: Record<SSO_PROVIDER, { domains: Domains }> = {
  [SSO_PROVIDER_ID_GOOGLE]: { domains: GRAFIT_DOMAINS },
  [SSO_PROVIDER_ID_VINCI]: {
    domains: VINCI_DOMAINS,
  },
};

export const getSSOProviderIdFromDomain = (domain: string): SSO_PROVIDER | undefined => {
  return Object.entries(SSO_PROVIDER_DOMAIN_MAP).find(([_, value]) => value.domains.includes(domain))?.[0] as
    | SSO_PROVIDER
    | undefined;
};

export const getSSOProviderIdFromEmail = (email: string): SSO_PROVIDER | undefined => {
  const domain = email.split("@")[1];
  if (!domain) {
    return undefined;
  }
  return getSSOProviderIdFromDomain(domain);
};

function isSSOProvider(providerId: string): providerId is SSO_PROVIDER {
  return Object.keys(SSO_PROVIDER_DOMAIN_MAP).includes(providerId);
}

export function getTenantFromProviderId(providerId: string): Tenant | undefined {
  if (!isSSOProvider(providerId)) {
    return undefined;
  }
  const providerConfig = SSO_PROVIDER_DOMAIN_MAP[providerId];
  return domainToTenant(providerConfig.domains[0]);
}
